import React from 'react'
import classNames from 'classnames'

import styles from './index.less'
import { getBrowserInfo } from '@/utils/utils'
import { compareVersion } from '@/utils/system'

export const checkBrowser = () => {
    const browser = getBrowserInfo()

    if (browser.name === 'chrome') {
        return compareVersion(browser.version, '86') >= 0
    }

    return ['edge', 'chrome', 'safari'].includes(browser.name)
}

export default ({ className, ...restProps }) => {
    const allowed = checkBrowser()

    if (allowed) {
        return null
    }

    return (
        <div className={classNames(styles.container, className)} {...restProps}>
            <img
                className={styles.noticeIcon}
                src="https://assets.sursung.com/activity/20240222/3E4371906BBF435ABD67932E7B19F28C1708586424813.svg"
                alt=""
            />
            <div className={styles.tipBox}>
                您的浏览器版本过低，可能导致某些功能异常或无法正常使用，请使用Chrome浏览器
                <a href="https://www.google.cn/intl/zh-CN/chrome" target="_blank" rel="noreferrer noopener">
                    <img
                        className={styles.icon}
                        src="https://assets.sursung.com/activity/2024_imgs/dis/front/141CF5E666B0462CB36CA9EDBC202E2B1620372062547.png"
                        alt=""
                        width="16"
                        height="16"
                    />
                    下载Chrome
                </a>
            </div>
        </div>
    )
}
